import React from "react";
import Scaffold from "../commons/scaffold/scaffold";
import { VMProvider } from "../commons/base/providers/provider";
import SoldOutAndCompletionDashboardViewModel from "./view_models/sold_out_and_completion_dashboard_view_model";
import SoldOutModalWidget from "./widgets/sold_out_modal_widget";
import SizedDiv from "../commons/ui/sized_div";
import CheckFormWidget from "../commons/ui/checkbox_form/check_form_widget";
import SoldOutCountPerLocationWidget from "./widgets/sold_out_count_per_location_widget";
import SoldOutTableWidget from "./widgets/sold_out_table_widget";
import SoldOutOtherMenuTableWidget from "./widgets/sold_out_other_menu_table_widget";
import "./styles/completion_dashboard.css";

export default class SoldOutAndCompletionDashboard extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider
                create={() => new SoldOutAndCompletionDashboardViewModel()}
            >
                {(vm) => (
                    <Scaffold
                        isShowLoading={
                            vm.completionData.length === 0 &&
                            vm.soldOutPerOutletMap.size === 0
                        }
                    >
                        {/* Split Screen */}
                        <div className="grid grid-cols-2 h-full">
                            {/* Completion Order Screen */}
                            <div
                                id="CompletionDashboardSplitScreen"
                                className="bg-slate-500"
                            >
                                {vm.completionErrorMessage.length > 0 && (
                                    <h1 className="text-red-500 text-3xl text-center font-bold">
                                        {vm.completionErrorMessage}
                                    </h1>
                                )}

                                <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                    Cooking Time Dashboard
                                </h1>

                                <table>
                                    <tr>
                                        <th>Outlet Name</th>
                                        <th>Kitchen</th>
                                        <th>Max Cooking Time</th>
                                        <th>Driver</th>
                                        <th>To Customer</th>
                                        <th>Max Time</th>
                                    </tr>
                                    {vm.completionData.map((model) => (
                                        <tr>
                                            <td>{model.outlet_name}</td>
                                            <td>{model.kitchen_record_qty}</td>
                                            <td>{model.max_cooking_time}</td>
                                            <td>{model.driver_record_qty}</td>
                                            <td>{model.to_customer}</td>
                                            <td>{model.max_time}</td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                            {/* Sold Out Live Dashboard */}
                            <div
                                id="SoldOutScreen"
                                className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-7 relative"
                            >
                                {vm.isShowingSoldOutModal && (
                                    <SoldOutModalWidget
                                        soldoutLocationCountData={
                                            vm.soldOutLocationCountMap
                                        }
                                        onClose={() =>
                                            vm.setIsShowingSoldOutModal(false)
                                        }
                                    />
                                )}

                                <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                    Sold Out Live Dashboard
                                </h1>

                                {vm.soldOutErrorMessage.length > 0 && (
                                    <h1 className="text-red-500 text-3xl text-center font-bold">
                                        {vm.soldOutErrorMessage}
                                    </h1>
                                )}

                                {/* SOLD OUT TABLE SECTION */}
                                <SoldOutTableWidget
                                    soldOutData={vm.filteredPrioritySoldOutData}
                                />

                                <SizedDiv height={16} />

                                {/* OTHER MENUS SECTION */}
                                <CheckFormWidget
                                    label="Tampilkan Menu Lainnya"
                                    isSelected={vm.isShowingSoldOutOtherMenus}
                                    onChanged={(value) =>
                                        vm.setIsShowingOtherSoldOutMenus(value)
                                    }
                                />

                                {vm.isShowingSoldOutOtherMenus && (
                                    <SoldOutOtherMenuTableWidget
                                        soldOutData={
                                            vm.filteredOtherSoldOutData
                                        }
                                    />
                                )}

                                <SizedDiv height={16} />

                                {/* SUMMARY SOLD OUT PER LOCATION SECTION */}
                                <h1 className="text-white text-3xl text-center font-bold flex-grow">
                                    Jumlah Lokasi setiap Menu Sold Out
                                </h1>
                                <SizedDiv height={8} />
                                <SoldOutCountPerLocationWidget
                                    soldOutCountPerLocationData={
                                        vm.soldOutLocationCountMap
                                    }
                                />

                                {/* SHOW POP UP SUMMARY BUTTON */}
                                <div className="fixed bottom-4 right-4">
                                    <button
                                        className="px-4 py-4 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                                        onClick={() =>
                                            vm.setIsShowingSoldOutModal(true)
                                        }
                                    >
                                        Summary
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
